































import _ from 'lodash';
import { Component, Vue, Model, Prop, Watch, Emit } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';

@Component
export default class OrdersShippingFilter extends Vue {
  @Prop({ default: {} }) items: Object;
  selectedLocal: Array<string> = [];
  @Model('change', { default: [] }) selected: Array<string>;
  @Emit('change') emitChange() {
    return this.selectedLocal;
  }
  @Watch('selected') watchSelected(selected: Array<string>, selectedOld: Object) {
    if (!_.isEqual(selected, selectedOld)) {
      this.selectedLocal = _.cloneDeep(selected);
    }
  }
  @Watch('selectedLocal') watchItems(selectedLocal: Object, selectedLocalOld: Object) {
    if (!_.isEqual(selectedLocal, selectedLocalOld)) {
      this.emitChange();
    }
  }
  mounted() {
    this.selectedLocal = _.cloneDeep(this.selected);
  }
}
